import {
  Grid,
  List,
  ListItem,
  ListItemText,
  SwipeableDrawer,
} from '@material-ui/core';
import {Menu} from '@material-ui/icons';
import {IUser} from 'MyModels';
import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import Variables from '../../../services/variables';
import logoSip from './logo-sip.png';
import './menu.css';

interface IProps {
  menuItems: any;
  loggedUser: IUser | null;
}

const MenuSwipeableDrawer: React.FC<IProps> = ({menuItems, loggedUser}) => {
  const {t} = useTranslation();
  const [state, setState] = useState({
    bottom: false,
    left: false,
    right: false,
    top: false,
  });

  const toggleDrawer = (side: string, open: boolean) => (event: any) => {
    if (
      event &&
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return;
    }

    setState({...state, [side]: open});
  };

  const imgProfile =
    loggedUser && loggedUser.thumb_src
      ? `url(${loggedUser.thumb_src})`
      : 'url(/images/profile.png)';

  const sideList = (side: any) => (
    <div
      className="drawer-menu"
      role="presentation"
      onClick={toggleDrawer(side, false)}
      onKeyDown={toggleDrawer(side, false)}
    >
      <div className="drawer-header">
        <div className="user-avatar" style={{backgroundImage: imgProfile}} />
        {loggedUser && (
          <>
            <h1>{loggedUser.name}</h1>
            <h2>{loggedUser.login}</h2>
          </>
        )}
      </div>

      <List className="menu-items">
        {menuItems.map((item: any, key: any) => (
          <Link
            to={item.route || '#logout'}
            onClick={item.onClick}
            key={String(key)}
          >
            <ListItem className="list-item" button={true}>
              {item.icon}
              <ListItemText className="list-item-text" primary={item.name} />
            </ListItem>
          </Link>
        ))}
      </List>
      <div className="drawer-footer">
        <span className="version-label secondary-text">
          {Variables.APP_VERSION}
        </span>
        <hr />
        <Grid
          item={true}
          container={true}
          direction="row"
          justify="space-around"
          alignItems="center"
        >
          <small className="secondary-text">
            {t('layout.desenvolvido-por')}
          </small>
          <img src={logoSip} alt="SIP eventos" height="30" />
        </Grid>
      </div>
    </div>
  );

  return (
    <>
      <div className="bar">
        <button type="button" onClick={toggleDrawer('left', true)}>
          <Menu fontSize="large" />
        </button>
      </div>

      <SwipeableDrawer
        open={state.left}
        onClose={toggleDrawer('left', false)}
        onOpen={toggleDrawer('left', true)}
      >
        {sideList('left')}
      </SwipeableDrawer>
    </>
  );
};

export default MenuSwipeableDrawer;



// WEBPACK FOOTER //
// ./src/shared/components/menu/Menu.tsx